import React from 'react'
import PropTypes from 'prop-types'
import debug from 'debug'

import ErrorStore from '~src/store/errors/errors.store'


const log = debug(`sl_connect_capture_manager/${module.id}`);

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {

    // You can also log the error to an error reporting service
    if (!!ErrorStore.log) {
      ErrorStore.log(error, errorInfo)
    } else {
      log(error, errorInfo)
    }
  }

  render () {
    const {
      children
    } = this.props

    const {
      hasError,
      error
    } = this.state

    if (hasError) {
      // You can render any custom fallback UI
      return (
        <React.Fragment>
          <h1>Something went wrong.</h1>
          <pre>{error}</pre>
        </React.Fragment>
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any
}
